import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConstruction,
  defaultCosts,
  defaultDescription,
  defaultObjectNumbers,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentHouseRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    price: validationRules.price,
    plotArea: validationRules.plotArea,
  },
  otherFacilities: {
    totalFloorsNumber: validationRules.totalFloors,
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    usableArea: validationRules.usableArea,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  objectNumbers: defaultObjectNumbers,
  costs: {
    ...defaultCosts,
    heatingCosts: validationRules.heatingCosts,
    courtageNote: validationRules.courtageNote,
    courtage: validationRules.courtage,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  construction: defaultConstruction,
  tenantDocuments: { solvency: [], rental: [], income: [], selfReport: [], identification: [] },
  apiSearchData: defaultApiSearchData,
}
